module.exports = __webpack_public_path__ + "static/media/sps.813d9f72.png";